<div class="modal-header h5">
  Insert Quicktext
  <button type="button" class="btn btn-outline-dark btn-sm px-2 py-1" (click)="activeModal.dismiss()" title="Close">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body">
  <div>
    <input class="form-control p-2" type="text" placeholder="Start typing to filter the list by title"
      (input)="onFilterTextChanged($event)" />
  </div>
  <div class="tx-table">
    <header class="grid">
      <div class="g-col-3">Title</div>
      <div class="g-col-2">Shortcut</div>
      <div class="g-col-6">Text</div>
      <div class="g-col-1">Actions</div>
    </header>
    <div id="quicktext-list">
      <div *ngFor="let q of filteredQuicktexts" class="grid tx-table-row py-2">
        <div class="g-col-3 text-truncate" [tooltipIfTruncated]="q.title">{{ q.title }}</div>
        <div class="g-col-2 text-truncate" [tooltipIfTruncated]="q.shortcut">{{ q.shortcut }}</div>
        <div class="g-col-6 text-truncate" [tooltipIfTruncated]="q.text">{{ q.text }}</div>
        <div class="g-col-1">
          <button type="button" class="btn btn-outline-primary btn-sm" (click)="insertQuicktext(q.text)"
            title="Insert quicktext">
            Insert
          </button>
        </div>
      </div>
    </div>
  </div>
</div>